const toBool = (value, fallback = true) => {
  if (value === "" || value == null) return fallback;
  if (typeof value === "boolean") return value;
  const normalized = String(value).trim().toLowerCase();
  if (["true", "1", "yes", "on"].includes(normalized)) return true;
  if (["false", "0", "no", "off"].includes(normalized)) return false;
  return fallback;
};

export const isAffiliateAttributionEnabled = () =>
  toBool(process.env.REACT_APP_ENABLE_AFFILIATE_ATTRIBUTION, true);

export const isAffiliateAttributionV2Enabled = () =>
  isAffiliateAttributionEnabled() &&
  toBool(process.env.REACT_APP_ENABLE_AFFILIATE_ATTRIBUTION_V2, false);
